import React, { useContext, useEffect, useMemo } from 'react'
import { AppContext } from '@/shared/contexts/AppContext'
import clsx from 'clsx'
import { EUploadStep } from '@/shared/types/upload'
import { useRouter } from 'next/router'
import useAppVersion from '@/hooks/useAppVersion'
import Header from '@/components/templates/Shared/Header/Header'
import { TermsOfService } from '@/components/templates/Shared/TermsOfService/TermsOfService'

import dynamic from 'next/dynamic'

const AnimatePresence = dynamic(() => import('framer-motion').then((mod) => mod.AnimatePresence), { ssr: false })
interface ILayout {
  children: any
}

const Layout = ({ children }: ILayout) => {
  const { setError, currentStep, isSubscriber } = useContext(AppContext)

  const router = useRouter()

  useAppVersion()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const displayBackground = useMemo(
    () =>
      router.pathname !== '/' &&
      router.pathname !== '/comparator' &&
      (router.pathname !== '/upload' || currentStep !== EUploadStep.MAIN),
    [currentStep, router.pathname]
  )

  const onClick = () => {
    window.location.replace(window.location.origin)
  }

  return (
    <div className={clsx(displayBackground && 'tablet:bg-gray-50')}>
      <div className="flex flex-col items-center justify-center w-full min-screen-height">
        <Header isSubscriber={isSubscriber} onClick={onClick} displayBackground={displayBackground} />
        <AnimatePresence>{children}</AnimatePresence>
      </div>

      <TermsOfService />
    </div>
  )
}

export default Layout
